<template>
  <div id="languages-overlay-d"  v-if="showIt == true" style="display:block;"  >
      <div id="languages-d">
          <div @click="closeLanguage()" class="close-button-language">
          </div>
          <div class="header" style="font-size: 36px;line-height: 1.2;text-align: center;font-family: 'LatoBlack';padding: 0 24px 32px 24px;color:#009de6;" ><span style="">{{ $t('languages.title')  }}</span> <span>{{ $t('languages.subtitle')  }}</span></div>
          <div id="languages-list-d">
            <template v-for="( value, key ) in locales">
              <a style="cursor:pointer;font-family: 'LatoRegular';" :style="( getLang && getLang === key ? 'color:rgb(0, 157, 230);' : '' )" @click="changeLocale(key)" aria-disabled="true" class="language" :class="( getLang && getLang === key ? 'languageCustomBlue' : 'languageCustom' )" >{{value}}</a>
            </template>
          </div>
      </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "Language",
  data() {
    return {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
        mode: 'cors', // no-cors, *cors, same-origin
        cache: 'no-cache', // *default, no-cache, reload, force-cache, only-if-cached
        credentials: 'same-origin'
      },
      locales: {
        "en": "English",
        "zh": "中文（简体）",
        "es": "Español",
        "pt": "Português",
        "ru": "Русский",
        "ja": "日本語",
        "de": "Deutsch",
        "fr": "Français",
        "ko": "한국어",
        "tr": "Türkçe",
        "it": "Italiano",
        "bg": "Български",
        "cs": "Čeština",
        "da": "Dansk",
        "nl": "Nederlands",
        "et": "Eesti",
        "fi": "Suomi",
        "el": "Ελληνικά",
        "hu": "Magyar",
        "id": "Bahasa Indonesia",
        "lv": "Latviešu",
        "lt": "Lietuvių",
        "nb": "Norsk (Bokmål)",
        "pl": "Polski",
        "ro": "Română",
        "sk": "Slovenčina",
        "sl": "Slovenščina",
        "sv": "Svenska",
        "uk": "Українська"
    },  
      
    };
  },
  computed: {
    showIt() {
      return this.$store.getters.languageOpen
    },
    isLogged() {
      return this.$store.getters.userLoggedIn;
    },
    getID() {
      return this.$store.getters.userUniq;
    },
    getLang() {
      return this.$store.state.activeLang;
    }
  },
  beforeDestroy() {
    this.$store.commit('updateLanguageOpen', false);
  },
  mounted() {
   
  },
  methods: {

    closeLanguage() {
      this.$store.commit('updateLanguageOpen', false);
    },
    changeLocale(lang) {
      
      this.$i18n.locale = lang;
      this.activeLang = lang;
      this.$store.commit("updateActiveLang", lang);

      if( this.$store.state.userLoggedIn )
      {
        axios.patch(this.$store.getters.enviromentAdminURL + '/language', { id: this.$store.state.userUniq,lang },
          { headers: this.headers })
          .then(response => {
            this.closeLanguage();
          })
          .catch(e => {
            this.closeLanguage();
            this.errors.push(e)
          })
      }
      else
      {
        this.closeLanguage();
      }
    },
  }
};
</script>
<style>
  *{
      margin: 0;
      padding: 0;
      box-sizing: border-box;
      scroll-behavior: smooth;
      scroll-padding: 150px;
  }

  .close-button-language {
    position: absolute;
    cursor: pointer;
    top: 20px;
    right: 20px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background-color: rgb(231, 231, 231);
    background-image: url(https://data.pixcham.com/preview/cancel_black.svg);
    background-position: center;
    background-repeat: no-repeat;
    background-size: 50%;

  }
 
  .text-gradient
  {
      background-image: linear-gradient( 90deg, var(--gradient-l), var(--gradient-r));
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
  }

  html, body
  {
      margin: 0; padding: 0; font-family: Latoregular; font-size: 16px; color: #282731;
      width: 100%;
      overflow-x: hidden;
      overflow-y: auto;
      font-family: 'LatoRegular';
  }

  #languages-overlay-d
  {
      display: block;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      z-index: 9999;
      background: rgba(0,0,0,0.25);
  }

  #languages-overlay-d #languages-d {
          position: fixed;
          background-color: white;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          border-radius: 3.2vh;
          box-shadow: 0 4vh 24vh rgba(0,0,0,0.5);
          padding: 48px;
  }

  #languages-overlay-d #languages-d div.header
  {
      font-size: 36px !important;
      line-height: 1.2;
      color: #282731;
      text-align: center;
      font-family: 'LatoBlack';
      
      padding: 0 24px 32px 24px;
  }

 
      
  #languages-overlay-d #languages-list-d
  {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 4px 64px;    
  }

  #languages-overlay-d #languages-list-d a
  {
      text-decoration: none; color: inherit;
  }

  #languages-overlay-d #languages-list-d a:hover
  { 
    text-decoration: underline; 
  }
  
  .languageCustom
  {
      text-decoration: none; 
  }

  .languageCustom:hover{ color:#282731; text-decoration-color: #282731; text-decoration: underline !important; }
      

  .languageCustomBlue
  {
      text-decoration: none; 
    

  }

  .languageCustomBlue:hover{ text-decoration-color: rgb(0, 157, 230); text-decoration: underline !important; }
      

  @font-face {
    font-family: 'LatoBold';
    font-style: normal;
    font-weight: 700;
    src: url(../assets/fonts/LatoLatin/fonts/LatoLatin-Bold.ttf);
  }
  @font-face {
    font-family: 'LatoBlack';
    font-style: normal;
    font-weight: 900;
    src: url(../assets/fonts/LatoLatin/fonts/LatoLatin-Black.ttf);
  }
  
  @font-face {
    font-family: 'LatoRegular';
    font-style: normal;
    font-weight: 400;
    src: url(../assets/fonts/LatoLatin/fonts/LatoLatin-Regular.ttf);
  }
  @font-face {
    font-family: 'LatoSemi';
    font-style: normal;
    font-weight: 600;
    src: url(../assets/fonts/LatoLatin/fonts/LatoLatin-Semibold.ttf);
  }
  @font-face {
    font-family: 'LatoMid';
    font-style: normal;
    font-weight: 600;
    src: url(../assets/fonts/LatoLatin/fonts/LatoLatin-Medium.ttf);
  }



</style>